import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { exportToExcel } from "../../utils/excelExportHelper";
import SalesPaymentsDialog from "../../components/Sale/SalesPaymentsDialog";
import SaleDetailDialog from "../../components/Sale/SaleDetailDialog";
import SaleReceipt from "../../components/Sale/SaleReceipt";
import { useNavigate } from "react-router-dom";
import SaleListService from "../../services/SaleListService";

const currency = new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" });
const fmtMoney = (v) => currency.format(v ?? 0);
const fmtDate = (isoOrDate) => (isoOrDate ? new Date(isoOrDate).toLocaleDateString("tr-TR") : "");

const statusOptions = [
  { label: "Tümü", value: null },
  { label: "Tam Ödendi", value: "Paid" },
  { label: "Kısmi Ödeme", value: "Partial" },
  { label: "Borçlu", value: "Unpaid" },
];

export default function SalesList() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  const navigate = useNavigate();

  const receiptRef = useRef(null);
  const printMenuRef = useRef(null);
  const activeSaleIdRef = useRef(null);
  const [activeSaleId, setActiveSaleId] = useState(null);

  const handleExport = () => {
    const headers = [
      { label: "Satış No", key: "saleNumber" },
      { label: "Müşteri Adı", key: "customerName" },
      { label: "Tarih", key: "formattedDate" },
      { label: "Ödeme Durumu", key: "statusText" },
      { label: "Toplam Tutar (TL)", key: "grandTotalFormatted" },
      { label: "Ödenen Tutar (TL)", key: "paidAmountFormatted" },
      { label: "Kalan Tutar (TL)", key: "remainingAmountFormatted" }
    ];

    const dataToExport = rows.map(r => ({
      ...r,
      formattedDate: r.saleDate ? new Date(r.saleDate).toLocaleDateString("tr-TR") : "",
      statusText: r.status === "Paid" ? "Tam Ödendi" : r.status === "Partial" ? "Kısmi Ödeme" : "Borçlu",
      grandTotalFormatted: (r.grandTotal || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 }),
      paidAmountFormatted: (r.paidAmount || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 }),
      remainingAmountFormatted: (r.remainingAmount || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })
    }));

    exportToExcel(dataToExport, headers, "toptan_satis_listesi");
  };

  const [paymentsSaleId, setPaymentsSaleId] = useState(null);
  const [paymentsOpen, setPaymentsOpen] = useState(false);

  const [detailSaleId, setDetailSaleId] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const openDetail = (saleId) => {
    setDetailSaleId(saleId);
    setDetailOpen(true);
  };

  const openPayments = (saleId) => {
    setPaymentsSaleId(saleId);
    setPaymentsOpen(true);
  };
  const refreshList = () => {
    fetchSales();
  };
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showBalances, setShowBalances] = useState(false);
  const [isSummaryExpanded, setIsSummaryExpanded] = useState(false);

  const [startDate, setStartDate] = useState(() => new Date());
  const [endDate, setEndDate] = useState(() => new Date());
  const [status, setStatus] = useState(null);
  const [global, setGlobal] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const toLocalYMD = (d) => {
    if (!(d instanceof Date)) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };
  const toast = useRef(null);

  const fetchSales = async (sDate, eDate) => {
    try {
      debugger;
      setLoading(true);
      const today = new Date();

      const finalStart = (sDate instanceof Date) ? sDate : startDate;
      const finalEnd = (eDate instanceof Date) ? eDate : endDate;

      const params = {
        StartDate: toLocalYMD(finalStart ?? today),
        EndDate: toLocalYMD(finalEnd ?? today),
      };

      // sadece varsa ekle
      if (status) {
        params.Status = status; // "Paid" | "Partial" | "Unpaid"
      }

      const res = await SaleListService.getSales(params);
      if (res) {
        setRows(res);
      }
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Hata",
        detail: err.message || "Satış listesi alınamadı.",
        life: 4000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusBody = (row) => {
    const map = {
      Paid: { label: "Tam Ödendi", severity: "success" },
      Partial: { label: "Kısmi Ödeme", severity: "warning" },
      Unpaid: { label: "Borçlu", severity: "danger" },
    };
    const s = map[row.paymentStatus] || map.Unpaid;

    const types = {
      1: { label: "PEŞİN", color: "text-blue-600 bg-blue-50" },
      2: { label: "AÇIK HESAP", color: "text-purple-600 bg-purple-50" },
      3: { label: "VADELİ", color: "text-orange-600 bg-orange-50" }
    };
    const t = types[row.customerReceivableType] || { label: "BİLİNMİYOR", color: "text-slate-400 bg-slate-50" };

    return (
      <div className="flex flex-col items-center gap-1.5">
        <Tag value={s.label} severity={s.severity} rounded className="text-[9px]" />
        <span className={`font-black text-[9px] px-2 py-0.5 rounded-full ${t.color}`}>{t.label}</span>
      </div>
    );
  };

  const printMenuItems = [
    {
      label: 'Yazdırma Seçenekleri',
      items: [
        {
          label: 'Bilgi Fişi',
          icon: 'pi pi-print',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'info')
        },
        {
          label: 'Tahsilat Makbuzu',
          icon: 'pi pi-money-bill',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'collection')
        },
        {
          label: 'Detaylı Bilgi Fişi',
          icon: 'pi pi-file-pdf',
          command: () => receiptRef.current.print(activeSaleIdRef.current, 'detailed')
        }
      ]
    }
  ];

  const satisToplam = rows.reduce((sum, r) => sum + (r.grandTotal || 0), 0);
  const tahsilatToplam = rows.reduce((sum, r) => sum + (r.paidTotal || 0), 0);
  const kalanToplam = rows.reduce((sum, r) => sum + (r.balanceTotal || 0), 0);

  return (
    <div className="bg-[#f8fafc] min-h-screen animate-fade-in">
      <Toast ref={toast} appendTo={mounted ? document.body : "self"} />

      <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden no-print">
        {/* Modern Header */}
        <div className="!bg-slate-200 dark:!bg-slate-800 border-b border-slate-200 dark:border-slate-700 px-4 py-4 md:px-6 md:py-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-emerald-600 p-4 rounded-xl shadow-md shadow-emerald-500/20">
              <i className="pi pi-shopping-cart text-white text-lg"></i>
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-black text-slate-900 dark:text-white uppercase tracking-tight">Satış Listesi</h1>
              <p className="text-slate-500 dark:text-slate-400 text-xs font-bold italic">Satış Hareketleri ve Ödemeler</p>
            </div>
          </div>
          <div className="flex gap-2 self-stretch md:self-auto justify-end">
            <Button
              label="SATIŞ YAP"
              icon="pi pi-plus"
              className="!bg-emerald-600 border-none hover:!bg-emerald-700 px-5 py-2.5 rounded-xl font-black text-xs shadow-lg shadow-emerald-500/20 transition-all active:scale-95 text-white"
              onClick={() => navigate("/sales/productsale")}
            />
            <Button
              label="VERİLERİ DIŞARI AKTAR"
              icon="pi pi-file-export"
              className="!bg-slate-700 border-none hover:!bg-slate-800 px-5 py-2.5 rounded-xl font-black text-xs shadow-lg shadow-slate-500/20 transition-all active:scale-95"
              onClick={handleExport}
            />
          </div>
        </div>

        {/* Filter Bar */}
        <div className="p-4 bg-slate-50 dark:bg-slate-900/30 border-b border-slate-200 dark:border-slate-700">
          <div className="flex flex-wrap items-end gap-4">
            <div className="flex flex-col gap-1.5 flex-1 sm:flex-none">
              <label className="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Başlangıç Tarihi</label>
              <div className="bg-white dark:bg-slate-800 p-1 h-[40px] rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm flex items-center">
                <Calendar
                  value={startDate}
                  onChange={(e) => setStartDate(e.value ?? null)}
                  readOnlyInput
                  dateFormat="dd.mm.yy"
                  locale="tr"
                  placeholder="Başlangıç"
                  showIcon
                  className="w-full sm:w-36"
                  inputClassName="border-none py-0 font-bold text-slate-700 dark:text-slate-200 text-xs bg-transparent"
                  appendTo={document.body}
                />
              </div>
            </div>

            <div className="flex flex-col gap-1.5 flex-1 sm:flex-none">
              <label className="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Bitiş Tarihi</label>
              <div className="bg-white dark:bg-slate-800 p-1 h-[40px] rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm flex items-center">
                <Calendar
                  value={endDate}
                  onChange={(e) => setEndDate(e.value ?? null)}
                  readOnlyInput
                  dateFormat="dd.mm.yy"
                  locale="tr"
                  placeholder="Bitiş"
                  showIcon
                  className="w-full sm:w-36"
                  inputClassName="border-none py-0 font-bold text-slate-700 dark:text-slate-200 text-xs bg-transparent"
                  appendTo={document.body}
                />
              </div>
            </div>

            <div className="flex flex-col gap-1.5 flex-1 sm:flex-none">
              <label className="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Ödeme Durumu</label>
              <div className="bg-white dark:bg-slate-800 p-1 h-[40px] rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm flex items-center">
                <Dropdown
                  value={status}
                  options={statusOptions}
                  onChange={(e) => setStatus(e.value)}
                  placeholder="Tüm Durumlar"
                  className="w-full sm:w-44 border-none shadow-none font-bold text-slate-700 dark:text-slate-200 text-xs bg-transparent"
                  optionLabel="label"
                  optionValue="value"
                  showClear
                  appendTo="self"
                />
              </div>
            </div>

            <div className="flex flex-col gap-1.5 flex-1 md:w-64">
              <label className="text-[10px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Hızlı Arama</label>
              <div className="relative h-[40px]">
                <i className="pi pi-search absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs z-10"></i>
                <InputText
                  value={global}
                  onChange={(e) => {
                    setGlobal(e.target.value);
                    setFilters((prev) => ({
                      ...prev,
                      global: { ...prev.global, value: e.target.value },
                    }));
                  }}
                  placeholder="Tabloda ara..."
                  className="w-full !pl-9 !py-2 bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-xl font-bold shadow-sm text-xs h-full"
                />
              </div>
            </div>

            <div className="flex items-center gap-2">
              <Button
                icon="pi pi-filter"
                label="FİLTRELE"
                onClick={fetchSales}
                className="!bg-emerald-600 border-none hover:!bg-emerald-700 px-5 h-[40px] rounded-xl font-black text-[10px] shadow-md shadow-emerald-600/10 text-white transition-all active:scale-95"
              />
              <Button
                icon="pi pi-refresh"
                onClick={() => {
                  const t = new Date();
                  setStartDate(t);
                  setEndDate(t);
                  setStatus(null);
                  setGlobal("");
                  setFilters((f) => ({ ...f, global: { ...f.global, value: null } }));
                  fetchSales(t, t);
                }}
                className="p-button-text p-button-secondary bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl w-[40px] h-[40px] p-0 flex items-center justify-center shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 transition-all active:rotate-180"
                tooltip="Sıfırla"
              />
            </div>
          </div>
        </div>

        {/* Bilgi Kartları */}
        <div className="p-4 bg-slate-50 dark:bg-slate-900/40 border-b border-slate-200 dark:border-slate-700">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-4 bg-emerald-600 rounded-full"></div>
                <h2 className="text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest">Finansal Özet</h2>
              </div>
              <div className="flex items-center gap-2">
                <Checkbox inputId="showBalances" checked={showBalances} onChange={(e) => setShowBalances(e.checked)} />
                <label htmlFor="showBalances" className="text-[10px] font-black text-slate-500 dark:text-slate-400 cursor-pointer select-none uppercase tracking-wider">Tüm Tutarları Göster</label>
              </div>
            </div>

            <button
              type="button"
              onClick={() => setIsSummaryExpanded(!isSummaryExpanded)}
              className="
                group
                !w-8 !h-8
                flex-shrink-0
                rounded-xl
                bg-slate-200/60 hover:bg-slate-300/80
                dark:bg-slate-800 dark:hover:bg-slate-700
                text-slate-600 dark:text-slate-300
                hover:text-slate-800 dark:hover:text-white
                active:scale-95
                transition-all duration-300
                flex items-center justify-center border-none
              "
              title={isSummaryExpanded ? "Özeti Gizle" : "Özeti Göster"}
            >
              <i className={`pi pi-chevron-down text-[12px] transition-transform duration-300 ${isSummaryExpanded ? 'rotate-180' : ''}`} />
            </button>
          </div>

          {isSummaryExpanded && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 animate-fade-in">
              <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200/80 dark:border-slate-700/80 shadow-sm flex items-center justify-between">
                <div>
                  <p className="text-xs font-black text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">Satış Toplamı</p>
                  <h3 className="text-xl font-black text-blue-600 dark:text-blue-400 tracking-tight">
                    {showBalances ? fmtMoney(satisToplam) : "***"}
                  </h3>
                </div>
                <div className="w-2 h-8 rounded-lg !bg-blue-50 dark:bg-blue-950/30 flex items-center justify-center !text-blue-600 dark:text-blue-400 flex-shrink-0">
                  <i className="pi pi-shopping-cart text-sm" />
                </div>
              </div>

              <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200/80 dark:border-slate-700/80 shadow-sm flex items-center justify-between">
                <div>
                  <p className="text-xs font-black text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">Tahsilat Toplamı</p>
                  <h3 className="text-xl font-black text-emerald-600 dark:text-emerald-400 tracking-tight">
                    {showBalances ? fmtMoney(tahsilatToplam) : "***"}
                  </h3>
                </div>
                <div className="w-2 h-8 rounded-lg bg-emerald-50 dark:bg-emerald-950/30 flex items-center justify-center text-emerald-600 dark:text-emerald-400 flex-shrink-0">
                  <i className="pi pi-check-circle text-sm" />
                </div>
              </div>

              <div className="bg-white dark:bg-slate-800 p-4 rounded-xl border border-slate-200/80 dark:border-slate-700/80 shadow-sm flex items-center justify-between">
                <div>
                  <p className="text-xs font-black text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">Kalan Toplam</p>
                  <h3 className="text-xl font-black text-rose-600 dark:text-rose-400 tracking-tight">
                    {showBalances ? fmtMoney(kalanToplam) : "***"}
                  </h3>
                </div>
                <div className="w-2 h-8 rounded-lg bg-rose-50 dark:bg-rose-950/30 flex items-center justify-center text-rose-600 dark:text-rose-400 flex-shrink-0">
                  <i className="pi pi-exclamation-circle text-sm" />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="">
          <DataTable
            value={rows}
            loading={loading}
            paginator
            rows={20}
            rowsPerPageOptions={[10, 20, 50, 100]}
            removableSort
            scrollable
            showGridlines
            filters={filters}
            globalFilterFields={[
              "customerName",
              "grandTotal",
              "paidTotal",
              "balanceTotal",
              "saleDate",
            ]}
            sortField="saleDate"
            sortOrder={-1}
            className="p-datatable-sm sales-compact-table"
            rowClassName={() => "hover:bg-slate-50/80 transition-colors"}
            tableStyle={{ minWidth: "1050px" }}
          >
            <Column
              field="saleNo"
              header="İŞLEM / TARİH"
              body={(r) => (
                <div className="flex flex-col leading-tight">
                  <span className="font-black text-slate-700 uppercase tracking-tight text-sm">
                    {r.saleNo}
                  </span>
                  <span className="text-[10px] text-slate-400 font-bold">
                    {fmtDate(r?.saleDate)}
                  </span>
                </div>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3"
              className="py-2 px-3"
              style={{ width: 130 }}
            />

            <Column
              field="customerName"
              header="MÜŞTERİ"
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3"
              className="py-2 px-3"
              style={{ width: 190 }}
              body={(r) =>
                r.customerId > 0 ? (
                  <a
                    href={`/customers/detail/${r.customerId}`}
                    className="font-bold text-blue-600 hover:text-blue-800 underline cursor-pointer text-sm"
                  >
                    {r.customerName}
                  </a>
                ) : (
                  <span className="font-bold text-slate-600 text-sm">{r.customerName}</span>
                )
              }
            />

            <Column
              field="branchName"
              header="ŞUBE"
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3"
              className="py-2 px-3 text-sm font-bold text-slate-600"
              style={{ width: 140 }}
              body={(r) => r.branchName || "Merkez Şube"}
            />

            <Column
              field="grandTotal"
              header="GENEL TOPLAM"
              body={(r) => (
                <span className="font-black text-slate-800 text-sm">
                  {fmtMoney(r?.grandTotal)}
                </span>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-right"
              className="py-2 px-3"
              style={{ textAlign: "right", width: 140 }}
            />

            <Column
              field="paidTotal"
              header="TAHSİLAT"
              body={(r) => (
                <span className="font-black text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md text-sm">
                  {fmtMoney(r?.paidTotal)}
                </span>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-right"
              className="py-2 px-3"
              style={{ textAlign: "right", width: 130 }}
            />

            <Column
              field="balanceTotal"
              header="KALAN"
              body={(r) => (
                <span
                  className={`font-black ${r?.balanceTotal > 0
                      ? "text-red-500 bg-red-50"
                      : "text-slate-400 bg-slate-50"
                    } px-2 py-1 rounded-md text-sm`}
                >
                  {fmtMoney(r?.balanceTotal)}
                </span>
              )}
              sortable
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-right"
              className="py-2 px-3"
              style={{ textAlign: "right", width: 130 }}
            />

            <Column
              field="dueDate"
              header="VADE TARİHİ"
              body={(r) =>
                r.dueDate ? (
                  <span className="font-bold text-orange-600 text-sm">
                    {fmtDate(r.dueDate)}
                  </span>
                ) : (
                  <span className="text-slate-300 text-sm">-</span>
                )
              }
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-center"
              className="py-2 px-3"
              style={{ textAlign: "center", width: 120 }}
            />

            <Column
              header="DURUM"
              body={statusBody}
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-center"
              className="py-2 px-3"
              style={{ textAlign: "center", width: 110 }}
            />

            <Column
              header="İŞLEMLER"
              headerClassName="bg-slate-50 text-slate-500 font-black text-[11px] uppercase py-2 px-3 text-center"
              className="py-2 px-3"
              style={{ textAlign: "center", width: 125 }}
              body={(row) => (
                <div className="flex items-center justify-center gap-1 no-print">
                  <Button
                    icon="pi pi-print"
                    className="p-button-text p-button-success hover:bg-emerald-50 rounded-lg w-8 h-8 p-0"
                    tooltip="Yazdır"
                    tooltipOptions={{ position: "top" }}
                    onClick={(e) => {
                      activeSaleIdRef.current = row.id;
                      setActiveSaleId(row.id);
                      printMenuRef.current.toggle(e);
                    }}
                  />

                  <Button
                    icon="pi pi-eye"
                    className="p-button-text p-button-secondary hover:bg-slate-100 rounded-lg w-8 h-8 p-0"
                    tooltip="Detay"
                    onClick={() => openDetail(row.id)}
                  />

                  <Button
                    icon="pi pi-wallet"
                    className="p-button-text p-button-info hover:bg-blue-50 rounded-lg w-8 h-8 p-0"
                    tooltip="Ödemeleri Gör"
                    onClick={() => openPayments(row.id)}
                  />
                </div>
              )}
            />
          </DataTable>
        </div>
      </div>

      <SalesPaymentsDialog
        saleId={paymentsSaleId}
        visible={paymentsOpen}
        onHide={() => setPaymentsOpen(false)}
        onChanged={refreshList}
      />

      <SaleDetailDialog
        saleId={detailSaleId}
        visible={detailOpen}
        onHide={() => setDetailOpen(false)}
      />

      <Menu model={printMenuItems} popup ref={printMenuRef} appendTo={document.body} />
      <SaleReceipt ref={receiptRef} />
    </div>
  );
}
